import { render, staticRenderFns } from "./MerchantsInvoices.vue?vue&type=template&id=e8128638&"
import script from "./MerchantsInvoices.vue?vue&type=script&lang=js&"
export * from "./MerchantsInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports